import { render } from "./AlfredController.vue?vue&type=template&id=b75631b6&scoped=true"
import script from "./AlfredController.vue?vue&type=script&lang=js"
export * from "./AlfredController.vue?vue&type=script&lang=js"

import "./AlfredController.vue?vue&type=style&index=0&id=b75631b6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b75631b6"]])

export default __exports__